import { groupBy, orderBy } from "lodash";

import { PortfolioFamiliesResponse } from "@fartherfinance/frontend/api/Investment/request/getPortfolioFamilies";
import { PortfolioFamiliesByIdResponse } from "@fartherfinance/frontend/api/Investment/request/getPortfolioFamiliesById";
import { PortfolioFamilyId } from "@fartherfinance/frontend/api/Investment/types";
import { HookResult } from "@fartherfinance/frontend/api/Types";

import {
  FAM,
  FARTHER_MODELS_TYPE_NAME,
} from "../../Advisor/Investments/constants";

type DropdownOptions = {
  id: PortfolioFamilyId;
  label: string;
}[];

export const customOptions: DropdownOptions = [
  {
    id: "shared" as PortfolioFamilyId,
    label: "Shared by your advisor",
  },
  {
    id: "custom" as PortfolioFamilyId,
    label: "Custom",
  },
];
// Categorize in FAM and Not FAM models
const categorizeProviderOptions = (
  portfolioFamilies: PortfolioFamiliesResponse
): [DropdownOptions, DropdownOptions] => {
  const filterNomFamPlans = portfolioFamilies.data
    .filter((pf) => pf.name !== FAM) // get everything BUT the Farther FAM portfolio family
    .map((pf) => {
      return {
        id: pf.portfolioFamilyId,
        label: pf.name,
      };
    });

  const filteredFamPlans = portfolioFamilies.data
    .filter((pf) => pf.name === FAM) // just get the Farther FAM portfolio family
    .map((pf) => {
      return {
        id: pf.portfolioFamilyId,
        label: FARTHER_MODELS_TYPE_NAME,
      };
    });

  return [orderBy(filterNomFamPlans, ["asc"]), filteredFamPlans];
};

export type PortfolioFamilyChildren = {
  id: PortfolioFamilyId;
  label: string;
};
const getPortfolioFamilyChildren = (
  response: HookResult<PortfolioFamiliesByIdResponse>
): PortfolioFamilyChildren[] => {
  return (response?.data?.data.children ?? [])
    .filter((p) => p.type === "Family")
    .map((pf) => {
      return {
        id: pf.portfolioFamily.portfolioFamilyId,
        label: pf.portfolioFamily.name,
      };
    });
};

type LabelOccurrence = { [key: string]: number };

const countRepeatedLabelValues = (
  objArray: { label: string }[]
): LabelOccurrence => {
  const groupedEntries = groupBy(objArray, (obj) => obj.label);

  const duplicates = Object.fromEntries(
    Object.entries(groupedEntries).map(
      ([label, v]) => [label, v.length] as const
    )
  );

  return duplicates;
};

export {
  categorizeProviderOptions,
  getPortfolioFamilyChildren,
  countRepeatedLabelValues,
};
